import { Vehicle } from '@/catalog/types';
import mapFuelTypeLabel from '@/catalog/utils/map-fuel-type-label';
import { capitalizeOnlyFirstLetter } from '@/util-conversion/misc/capitalize-only-first-letter';

export interface EssentialItem {
  title: string;
  value: string;
}

/**
 * Generates essential vehicle details for display
 */
export function getEssentialsData(vehicle: Vehicle): EssentialItem[] {
  return [
    {
      title: 'Mileage',
      value: vehicle.odometer
        ? `${vehicle.odometer.toLocaleString('en-US', { maximumFractionDigits: 0 })}`
        : '--',
    },
    { title: 'Drivetrain', value: vehicle.drivetrain || '--' },
    {
      title: vehicle?.is_electric ? 'MPGe' : 'MPG',
      value: `${vehicle.fuel_efficiency_city || '--'} cty / ${vehicle.fuel_efficiency_highway || '--'} hwy`,
    },
    {
      title: 'Fuel type',
      value: vehicle.fuel_type ? mapFuelTypeLabel(vehicle.fuel_type) : '--',
    },
    {
      title: 'Exterior',
      value: vehicle.exterior_color_basic
        ? capitalizeOnlyFirstLetter(vehicle.exterior_color_basic)
        : '',
    },
    {
      title: 'Interior',
      value: vehicle.interior_color
        ? capitalizeOnlyFirstLetter(vehicle.interior_color)
        : '',
    },
  ];
}
